__turbopack_context__.v({
  "carouselControls": "SOI7xq_carouselControls",
  "carouselSection": "SOI7xq_carouselSection",
  "description": "SOI7xq_description",
  "embla": "SOI7xq_embla",
  "embla__container": "SOI7xq_embla__container",
  "embla__next": "SOI7xq_embla__next",
  "embla__prev": "SOI7xq_embla__prev",
  "embla__slide": "SOI7xq_embla__slide",
  "imagesCarouselSection": "SOI7xq_imagesCarouselSection",
  "slideContent": "SOI7xq_slideContent",
  "textContainer": "SOI7xq_textContainer",
  "title": "SOI7xq_title",
});
